import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'globalSearch'
})
export class GlobalSearchPipe implements PipeTransform {

  transform(value_array, filter_key, search_term): any {
    if (search_term !== '') {
      return value_array.filter(
        item => item[filter_key].toString().toLowerCase().indexOf(search_term.toLowerCase()) > -1);
      } else {
      return value_array;
    }
  }

}
